import gql from 'graphql-tag'

export const fetchMinCartForCatalogQuery = gql(`
query ($cart_id: String!) {
  cart(
      cart_id: $cart_id
  ) {
    note_for_driver
    customer_order_number
    delivery_date
    delivery_method
    progress_bar_data {
      isFullTruck
      iMinimumOrderPallet
      iMaximumOrderPallet
      iMinimumOrderWeight
      iMaximumOrderWeight
      iMaximumOrderCash
      sOutletDeliveryMethod
      iTotalCartWeight
      iTotalCartPalletQty
      iMinLitersTank
      iMaxLitersTank
    }
    id
    ship_to_id
    grand_total_your_price_details
    total_liters
    items {
      id
      prices {
        price_details
        multi_deposit_details
        total_item_discount {
          value
        }
        price {
          value
        }
        favourites
        row_total {
          value
        }
        discounts {
          label
          amount {
            value
          }
        }
      }
      product {
        id
        volume_fe
        name
        posm_multiplier_flag
        posm_multiplier_value
        number_of_items_in_box
        catalog_product_name
        sku
        package_type
        image {
          url
        }
        bundle_product_details {
          sku
          catalog_product_name
          bundle_quantity
          price_per_unit_w_vat
          price_per_unit_wo_vat
          price_per_unit_wo_vat_discounted
          price_per_unit_w_vat_discounted
        }
        promo_price_leaflet {
          promo_price
          promo_price_percentage_with_tax
          promo_price_percentage_wo_tax
          promo_price_is_inside_delivery
          promo_price_valid_from
          promo_price_valid_to
          long_term_discount
          long_term_discount_percentage_with_tax
          long_term_discount_percentage_wo_tax
          base_price
          percentage
        }
        ... on BundleProduct {
          flexible_package_rules {
            validity_from
            validity_to
            max_number_of_packages
            max_number_of_items_in_package
            items {
              sku
              is_mandatory
              deal_condition
              min_number_orderable
              max_number_orderable
              validity_from
              validity_to
            }
          }
          bundle_price_details
          items {
            option_id
            title
            sku
            type
            required
            position
            your_price_sum
            your_price_sum_tax
            bundle_price
            options {
              uid
              id
              label
              quantity
              can_change_quantity
              price
              price_type
              is_default
              position
              product {
                id
                name
                image {
                  url
                }
                sku
                sku_product_detail_page
                price_range {
                  minimum_price {
                    regular_price {
                      value
                      currency
                    }
                  }
                }
                your_price
                your_price_tax
              }
            }
          }
        }
        __typename
      }
      quantity
      number_of_pallet_from_fe
      number_of_layer_from_fe
      quantity_from_fe
      number_of_pallet
      number_of_layer
      quantity_total
      product {
        number_of_products_on_layer
      }
      ... on BundleCartItem {
        bundle_options {
          uid
          label
          type
          values {
            id
            label
            sku
            price
            quantity
          }
        }
      }
    }
  }
}
`)
